declare global {
  interface WindowEventMap extends DexUIEventMap {}
  interface Window {
    xBrowserSessionId?: string;
    dexAccountId?: string | number;
  }
}

export const DEX_EVENTS = {
  APP_RESOURCE_UPDATE_EVENT: 'AppResourceUpdate',
} as const;

export interface DexUIEventMap {}
